import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const components: Components = {
  a: ({ children, ...props }) => (
    <a target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ),
  table: ({ ...props }) => (
    <div className="typeset-scroll">
      <table {...props} />
    </div>
  ),
};

interface ChatMarkdownProps {
  children: string;
}

export default function ChatMarkdown({
  children,
}: Readonly<ChatMarkdownProps>) {
  return (
    <div className="typeset typeset-chat">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
